import { memo } from 'react';

function CompanyDetailsIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#919EAB" fillOpacity="0.24" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 19H13C12.45 19 12 18.55 12 18V14C12 13.45 12.45 13 13 13H16C16.55 13 17 13.45 17 14V18C17 18.55 16.55 19 16 19ZM16 26H13C12.45 26 12 25.55 12 25V21C12 20.45 12.45 20 13 20H16C16.55 20 17 20.45 17 21V25C17 25.55 16.55 26 16 26ZM19 26H22C22.55 26 23 25.55 23 25V21C23 20.45 22.55 20 22 20H19C18.45 20 18 20.45 18 21V25C18 25.55 18.45 26 19 26ZM28 26H25C24.45 26 24 25.55 24 25V21C24 20.45 24.45 20 25 20H28C28.55 20 29 20.45 29 21V25C29 25.55 28.55 26 28 26ZM19 19H22C22.55 19 23 18.55 23 18V14C23 13.45 22.55 13 22 13H19C18.45 13 18 13.45 18 14V18C18 18.55 18.45 19 19 19ZM24 18V14C24 13.45 24.45 13 25 13H28C28.55 13 29 13.45 29 14V18C29 18.55 28.55 19 28 19H25C24.45 19 24 18.55 24 18Z"
        fill="#637381"
      />
    </svg>
  );
}

export default memo(CompanyDetailsIcon);
